import React from 'react';
import PropTypes from 'prop-types';
import withScopedTranslations from '../../../../withScopedTranslations/withScopedTranslations';

const InvoicesCell = ({
  t,
  url,
  onDownloadClick,
  id,
}) => {
  return (
    <a className="btn transparent" href={url} without rel="noreferrer" target="_blank" onClick={(e) => onDownloadClick(e, id)} download>
      <span>{t('download')}</span>
      <style jsx="true">{`
        .btn {
          display: inline;
          padding: 6px !important;
          width: min-content;
        }
      `}</style>
    </a>
  );
};

InvoicesCell.propTypes = {
  onDownloadClick: PropTypes.func,
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  url: PropTypes.string,
};

InvoicesCell.defaultProps = {
  url: '',
  onDownloadClick: null,
  id: null,
};

export default withScopedTranslations('tables.invoices_cell')(InvoicesCell);
